// UI ACTIONS
export const INCREMENT_TAB_INDEX = 'fulcrum/containers/ProjectCreatePage/INCREMENT_TAB_INDEX'
export const DECREMENT_TAB_INDEX = 'fulcrum/containers/ProjectCreatePage/DECREMENT_TAB_INDEX'
export const UPDATE_TAB_INDEX = 'fulcrum/containers/ProjectCreatePage/UPDATE_TAB_INDEX'
export const TOGGLE_COLLAPSE = 'fulcrum/containers/ProjectCreatePage/TOGGLE_COLLAPSE'
export const UPDATE_INPUT_VALUE = 'fulcrum/containers/ProjectCreatePage/UPDATE_INPUT_VALUE'
export const CLEAR_INPUT_VALUE = 'fulcrum/containers/ProjectCreatePage/CLEAR_INPUT_VALUE'
export const TOGGLE_COLLAPSE_CONTENT = 'fulcrum/containers/ProjectCreatePage/TOGGLE_COLLAPSE_CONTENT'
export const ENABLE_PRODUCT_CLASS = 'fulcrum/containers/ProjectCreatePage/ENABLE_PRODUCT_CLASS'
export const DISABLE_PRODUCT_CLASS = 'fulcrum/containers/ProjectCreatePage/DISABLE_PRODUCT_CLASS'

// DATA ACTIONS
export const UPDATE_REDIRECT = 'fulcrum/containers/ProjectCreatePage/UPDATE_REDIRECT'
export const UPDATE_PARTNER_SITE_FILTER = 'fulcrum/containers/ProjectCreatePage/UPDATE_PARTNER_SITE_FILTER'
export const UPDATE_PARTNER_SITE_SOURCE = 'fulcrum/containers/ProjectCreatePage/UPDATE_PARTNER_SITE_SOURCE'
export const UPDATE_PRODUCT_HIERARCHY_SOURCE = 'fulcrum/containers/ProjectCreatePage/UPDATE_PRODUCT_HIERARCHY_SOURCE'
export const UPDATE_PRODUCT_HIERARCHY_FILTER = 'fulcrum/containers/ProjectCreatePage/UPDATE_PRODUCT_HIERARCHY_FILTER'
export const UPDATE_PRODUCT_CLASS_FILTER = 'fulcrum/containers/ProjectCreatePage/UPDATE_PRODUCT_CLASS_FILTER'
export const UPDATE_PRODUCT_CLASS_SOURCE = 'fulcrum/containers/ProjectCreatePage/UPDATE_PRODUCT_CLASS_SOURCE'

// UI DATA Combined Actions
export const RESET_PARTNER_SITE_FILTER = 'fulcrum/containers/ProjectCreatePage/RESET_PARTNER_SITE_FILTER'
export const RESET_PRODUCT_HIERARCHY_FILTER = 'fulcrum/containers/ProjectCreatePage/RESET_PRODUCT_HIERARCHY_FILTER'
export const CLEAR_PROJECT_CREATE = 'fulcrum/containers/ProjectCreatePage/CLEAR_PROJECT_CREATE'
export const RESET_PRODUCT_CLASS_FILTER = 'fulcrum/containers/ProjectCreatePage/RESET_PRODUCT_CLASS_FILTER'
export const CREATE_PROJECT_START = 'fulcrum/containers/ProjectCreatePage/CREATE_PROJECT_START'

export const PartnerSiteEnum = Object.freeze({
  PARTNER: {
    value: 0,
    label: 'Partner',
  },
  ODM: {
    value: 1,
    label: 'ODM',
  },
  PARTNER_SITE: {
    value: 2,
    label: 'Partner Site',
  }
})

export const ProductHierarchyEnum = Object.freeze({
  SEGMENT: {
    value: 0,
    label: 'Segment',
  },
  LINE: {
    value: 1,
    label: 'Line',
  },
  FAMILY: {
    value: 2,
    label: 'Family',
  },
  PLATFORM: {
    value: 3,
    label: 'Platform',
  },
  SKU: {
    value: 4,
    label: 'Sku',
  },
  BRAND: {
    value: 5,
    label: 'Brand',
  }
})

export const ProductClassEnum = Object.freeze({
  PRODUCT_CLASS: {
    value: 0,
    label: 'Product Class',
  },
})
